export default {
	"name": "ThaliaChat",
	"stage": "integration",
	"mandanten": ["2", "2003"],
	"pagetypes": "all",
	"excludedPagetypes": ["login", "bestelluebersicht"],
	"requiresConsent": false,
	"serviceSettings": {
		"2": {
			"jspUrl": "https://integration.thalia.de/chatRest",
			"frontendId": "frontend-thalia-new",
			"scriptSrc": "https://ecdn.novomind.com/rules/la/nm.rules.js"
		},
		"2003": {
			"jspUrl": "https://app-integration.thalia.de/chatRest",
			"frontendId": "frontend-thalia-new-app",
			"scriptSrc": "https://ecdn.novomind.com/rules/la/nm.rules.js"
		}
	}
}
